/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_Aroma_Sampling_NoneInputs */

const vi_tea_package_aroma_sampling_none = /** @type {(inputs: Tea_Package_Aroma_Sampling_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có`)
};

/**

* @param {Tea_Package_Aroma_Sampling_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_aroma_sampling_none = /** @type {((inputs?: Tea_Package_Aroma_Sampling_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_Aroma_Sampling_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_aroma_sampling_none(inputs)
});